<template>
  <el-select
    v-model="text"
    v-loadmoretest="handleLoadMore"
    popper-class='lazy-select'
    :class="{'lazy-select_contorl': true, 'remote-mod': remote }"
    :loading="loading"
    :size="size"
    :loading-text="$lang('查询中...')"
    :multiple="multiple"
    :filterable="remote ? true : filterable"
    :remote="remote"
    :readonly="readonly"
    :remote-method="handleRemoteMethod"
    :collapse-tags="tags"
    :clearable="disabled ? false : clearable"
    :placeholder="placeholder"
    :allow-create="allowCreate"
    :reserve-keyword="reserveKeyword ? true : false"
    :multiple-limit="limit"
    :value-key="valueKey || 'id'"
    :disabled="disabled"
    @focus="handleFocus"
    @blur="handleBlur"
    @click.native="handleClick"
    @change="handleChange"
    @compositionupdate.native="handleComposition"
    @compositionstart.native="handleComposition"
    @compositionend.native="handleComposition"
  >
    <el-option v-for="(item, index) in netDic" :key="index" :disabled="item[disabledKey]" :label="getLabelText(item)" :value="props.valueObj ? item : item[valueKey]">
      <slot :name="prop + 'Type'" :label="labelKey" :value="valueKey" :item="item"></slot>
    </el-option>
  </el-select>
</template>

<script>
import create from '@components/avuex/core/create'
import props from '@components/avuex/core/common/props.js'
import event from '@components/avuex/core/common/event.js'

import { mapGetters } from 'vuex'
import { lang } from '@public/utils/filters.js'
import { sendDic } from '@components/avuex/core/common/dic'

export default create({
  name: 'select',

  mixins: [props(), event()],

  directives: {
    loadmoretest: {
      bind(el, binding) {
        const selectDom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        selectDom.addEventListener('scroll', function () {
          const condition = Math.floor(this.scrollHeight - this.scrollTop) <= this.clientHeight
          if (condition) binding.value()
        })
      }
    }
  },

  data() {
    return {
      loading: false,
      isOnComposition: false,
      previousQuery: null,
      netDic: [],
      pageCurrent: 1,
      pageSize: 20,
      // 下拉禁止
      loadDisabled: false
    }
  },

  props: {
    value: [Object, Array, Number, String],

    remote: {
      type: Boolean,
      default: false
    },

    tags: {
      type: Boolean,
      default: true
    },

    allowCreate: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Number,
      default: 99
    },

    filterable: {
      type: Boolean,
      default: false
    },

    isSearch: {
      type: Boolean,
      default: false
    },

    reserveKeyword: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters({ lang: 'lang' }),

    valueKey() {
      return this.props.value
    }
  },

  watch: {
    dic: {
      handler(val) {
        this.netDic = val
      },
      immediate: true
    },

    lang: {
      handler(val) {
        this.dic.forEach(item => {
          item.label = lang(item.name)
        })
      }
    },

    text: {
      handler(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      },
      immediate: true
    },

    dicUrl: {
      handler(val = '', oldval = '') {
        const npath = val.split('?')[0]
        const opath = oldval.split('?')[0]
        if (npath !== opath) this.handleRemoteMethod()
      },
      deep: true
    }
  },

  methods: {
    isKorean(text) {
      const reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi
      return reg.test(text)
    },

    handleComposition(event) {
      if (this.multiple || this.filterable) return
      const text = event.target.value
      if (event.type === 'compositionend') {
        this.isOnComposition = false
        this.$nextTick(_ => this.handleRemoteMethod(text))
      } else {
        const lastCharacter = text[text.length - 1] || ''
        this.isOnComposition = !this.isKorean(lastCharacter)
      }
    },

    handleRemoteMethod(query) {
      if (this.previousQuery === query || this.isOnComposition) return

      this.previousQuery = query

      if (!query) {
        this.netDic = []
        return
      }

      this.lazyReset()
      this.handleQuery()
    },

    async handleQuery(isFormLoad = false) {
      if (!isFormLoad) this.loading = true

      try {
        const res = await sendDic({
          url: this.dicUrl.replace('{{key}}', this.previousQuery).replace('{{current}}', this.pageCurrent).replace('{{size}}', this.pageSize),
          method: this.dicMethod,
          query: this.dicQuery,
          resKey: this.resKey,
          props: this.props
        })

        this.netDic = isFormLoad ? [...this.netDic, ...res] : res
        this.loadDisabled = isFormLoad && !res.length
        this.loading = false

        if (!isFormLoad) {
          this.$nextTick(() => {
            const el = document.querySelector('.lazy-select .el-select-dropdown__wrap')
            el && (el.scrollTop = 0)
          })
        }
      } catch (error) {
        this.loading = false
      }
    },

    handleLoadMore() {
      if (this.loadDisabled) return

      this.pageCurrent++
      // 查询
      this.handleQuery(true)
    },

    inNetDic(item) {
      if (this.validatenull(item[this.valueKey])) return true
      return !!this.netDic.find(o => o[this.valueKey] === item[this.valueKey])
    },

    clearDic() {
      this.netDic = []
    },

    // 重置
    lazyReset() {
      this.pageCurrent = 1
      this.loadDisabled = false
    }
  }
})
</script>

<style lang="scss">
.lazy-select_contorl {
  .el-select__tags {
    .el-tag {
      max-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
